import axios from 'axios'
import qs from 'qs'
import utils from '../utils'

const requestHeader = {
  method: 'POST',
  headers: {
    'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
  }
}
// 公共报名接口
export function postFormData (data, businessCardBase64) {
  let queryData = {
    jparams: JSON.stringify(data)
  }
  if (businessCardBase64) {
    queryData.image = businessCardBase64
  }
  return new Promise((resolve, reject) => {
    axios({
      url: `https://activity.9kacha.com/dataApi/activity_sign_in.php`,
      ...requestHeader,
      data: qs.stringify(queryData)
    })
      .then(res => {
        console.log('signUp, res', res)
        resolve(res)
      })
      .catch(err => {
        console.log('signUp, err', err)
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/api/postFormData.js